<!--<div class="btn-group" dropdown style="width:100%;" [autoClose]="true" [isOpen]="status.isopen" (isOpenChange)="change($event)" (blur)="toggleDropdown">
    <input type="text" class="form-control" id="cpville"   [(ngModel)]="search" (ngModelChange)="searchCPVille(search)" autocomplete="off"/>
    <ul *dropdownMenu class="dropdown-menu cpville" role="menu">
      <li role="menuitem" *ngFor="let item of resultCpVille; let i = index;" class="items" (click)="selectAdresse(item)">
        <a class="dropdown-item">
    {{ item.codePostal + ' / ' + item.ville}}
        </a>
      </li>
    </ul>
</div>-->

<app-autocomplete [placeholder]="placeholder" (searchfunction)="searchCPVille($event)" (selectfunction)="selectAdresse($event)"  [deleteSelectedValue]="deleteSelectedValue"
    [dropdownclass]="dropdownclass" (blurfunction)="blurfct()" [results]="resultCpVille" [label]="label" [disablefocus]="true" [defaultsearch]="iscp ? (item[cp] || '') : (item[ville] || '')"
    [active]="disable" [container]="container" [id]="class" [forceSelection]="true" [isClearResult]="true" (keyenterfunction)="keyEnter()"
    [activeVisibleChamp]="activeVisibleChamp" [visibleChamp]="visibleChamp" [material]="material"></app-autocomplete>
